import React from 'react';
import { Stack } from '@mui/material';
import AssetLogo from 'sections/AssetLogo';
import { Underwriter, useGetUnderwriterMemberInfoQuery } from 'graphql/types';

interface McaUnderwriterListWidgetProps {
  underwriter?: Underwriter;
  useCompactView?: boolean;
}

const McaUnderwriterListWidget: React.FC<McaUnderwriterListWidgetProps> = ({
  underwriter,
  useCompactView = false
}) => {
  const { data } = useGetUnderwriterMemberInfoQuery({
    skip: !underwriter?.id || !!underwriter?.logo,
    variables: { underwriterId: underwriter?.id as string },
  });

  const members = data?.getUnderwriterMemberInfo || [];

  const logos = underwriter?.logo
    ? [{ logo: underwriter.logo, name: underwriter.name || '' }]
    : members.length > 0
    ? members.slice(0, 3).map((m) => ({
        logo: m?.avatar || undefined,
        name: m?.name || ''
      }))
    : [{ logo: undefined, name: underwriter?.name || underwriter?.code || '?' }];

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      flex={1}
      mt={0.25}
      sx={{ width: '100%' }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        sx={{ overflow: "visible" }}
      >
        {logos.length > 1 ? (
          <Stack 
            direction="row" 
            alignItems="center"
            justifyContent="center"
            sx={{ overflow: "visible" }}
          >
            {logos.map((item, i) => (
              <span
                key={i}
                style={{
                  display: "inline-block",
                  position: "relative",
                  zIndex: i + 1,
                  marginLeft: i === 0 ? 0 : -10
                }}
              >
                <AssetLogo
                  logo={item.logo}
                  name={item.name}
                  size={useCompactView ? "xs" : "sm"}
                />
              </span>
            ))}
          </Stack>
        ) : (
          <AssetLogo
            logo={logos[0].logo}
            name={logos[0].name}
            size={useCompactView ? "xs" : "sm"}
          />
        )}
      </Stack>
    </Stack>
  );
};

export default McaUnderwriterListWidget;